export const contractAddressValue = "0x5d925179d119EaB346341c407041BaD2F11997F2";
export const myAccount = "0x2b033adc44bbc62a6084b079e3828c972b0da850";

